module.exports = __webpack_public_path__ + "img/nuvola_2.1a0df3ca.png";